import { Component } from '@angular/core';
import { ApiHomeRow } from '@tytapp/api';
import { ProvidesHomeCard } from '@tytapp/app/pages/home-page/home-cards.service';

@ProvidesHomeCard('*')
@Component({
    template: `
        <div class="alert alert-danger">

        No implementation for card type <code>{{ card.type }}</code>
        </div>
    `,
    styles: [
        `
        :host {
            display: flex;
            flex-direction: column;
            padding: 1em;
        }
        `
    ]
})
export class DefaultHomeCardComponent {
    card: ApiHomeRow;
    get title() { return `Unknown Card Type <code>${this.card?.type}</code>`; }
    readonly icon = '/assets/icons-2019/newsletters.svg';
}